import React, { Component } from "react"
import PropTypes from "prop-types"
import "lazysizes"
import "lazysizes/plugins/attrchange/ls.attrchange"

class Svg extends Component {
  static defaultProps = {
    iconName: "",
    fillColor: "",
    iconClass: "icon",
    stroke: "",
    renderContainer: true,
    isDecorative: false,
    label: "",
    title: "",
    desc: "",
  }

  render() {
    var styleFill = { fill: this.props.fillColor, stroke: this.props.stroke }
    if (this.props.renderContainer) {
      return (
        <span className={this.props.iconClass}>
          <svg
            tabIndex={this.props.isDecorative ? "-1" : ""}
            aria-hidden={this.props.isDecorative}
            aria-label={this.props.label}
            className={`svg-icon svg-icon--${this.props.iconName}`}
            style={styleFill}
          >
            {this.props.title ? <title>{this.props.title}</title> : null}
            {this.props.desc ? <desc>{this.props.desc}</desc> : null}
            <use href={`/dist/svg/symbols.svg#svg-${this.props.iconName}`}>&nbsp;</use>
          </svg>
        </span>
      )
    } else {
      return (
        <svg
          tabIndex={this.props.isDecorative ? "-1" : ""}
          aria-hidden={this.props.isDecorative}
          aria-label={this.props.label}
          className={`svg-icon svg-icon--${this.props.iconName}`}
          style={styleFill}
        >
          {this.props.title ? <title>{this.props.title}</title> : null}
          {this.props.desc ? <desc>{this.props.desc}</desc> : null}
          <use href={`/dist/svg/symbols.svg#svg-${this.props.iconName}`}>&nbsp;</use>
        </svg>
      )
    }
  }
}

Svg.propTypes = {
  iconName: PropTypes.string.isRequired, // Icon name is required as a string
  fillColor: PropTypes.string, // Fill color can be a string (e.g., color code)
  iconClass: PropTypes.string, // CSS class name, default string "icon"
  stroke: PropTypes.string, // Stroke color or width, optional string
  renderContainer: PropTypes.bool, // Boolean to determine if container renders
  isDecorative: PropTypes.bool, // Boolean indicating if icon is decorative
  label: PropTypes.string, // Accessible label, string if provided
  title: PropTypes.string, // Title text, optional string
  desc: PropTypes.string, // Description text, optional string
}

Svg.defaultProps = {
  iconName: "", // Default values for non-required props
  fillColor: "",
  iconClass: "icon",
  stroke: "",
  renderContainer: true,
  isDecorative: false,
  label: "",
  title: "",
  desc: "",
}

export default Svg
